<template>
    <transition name="fade">
        <div class="Viewer3D" v-show="viewer3DVisible"> <!-- @click="toggleViewer3D()" -->
            <div class="v3-container"> <!-- @click="$event.stopPropagation()" -->
                
                <!-- Toolbar -->
                <div class="v3-bar">
                    <transition name="fade">
                        <p class="v3-bar-name">{{name}}</p>
                    </transition>
                    <div class="v3-bar-buttons">  
                        <md-button class="md-icon-button" @click="toggleViewer3D()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- Loadingscreen -->
                <div id="v3-loadingScreen" class="v3-loadingscreen">
                    <div>
                        <img class="v3-logo" :src="publicPath+'/media/'+logoURL" alt="">
                        <div class="v3-text" id="v3-text">0%</div>
                        <svg class="v3-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                            </path>
                        </svg>
                    </div>
                </div>

                <!-- Animation Button -->
                <div class="v3-animation-button" v-if="hasAnimations" @click="playAnimation()">
                    <PlayCircleOutline/>
                </div>

                <!-- Canvas -->
                <Canvas id="v3-canvas" class="v3-canvas"/>  

            </div>         
        </div>  
    </transition>
</template>

<style scoped>
    .Viewer3D{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 5;
    }
    .v3-container{
        position: absolute;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 88%;
        height: 88%;
    }
    .v3-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .v3-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .v3-bar-buttons{
        margin-left: auto;
    }
    .v3-canvas{
        width: 100%;
        height: calc(100% - 46px);
        outline: none;
    }
    .material-design-icon {
        height: 2.4em;
        width: 2.4em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.4em;
        width: 2.4em;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
    .v3-loadingscreen{
        pointer-events: none;
        opacity: 0;
        transition: 1s opacity ease-in-out;
        position: absolute;
        width: 100%;
        height: calc(100% - 46px);
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .v3-logo{
        width: 350px;
    }
    .v3-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        margin: auto;
        display: block;
    }
    .v3-text{
        font-size: 24px;
        margin-top: 20px;
        color: var(--primaryColor);
        text-align: center;
        font-weight: bolder;
    }

    /* Animation-Button */
    .v3-animation-button{
        position: absolute;
        left: calc(50% - 20px);
        bottom: 20px;
        cursor: pointer;
        transition: transform .3s ease;
    }
    .v3-animation-button:hover{
        transform: scale(1.2);
    }

    .v3-animation-button .material-design-icon {
        height: 50px;
        width: 50px;
    }
    .v3-animation-button .material-design-icon> .material-design-icon__svg {
        fill: var(--primaryColor);
        height: 50px;
        width:  50px;
    }
</style>
    
<script>
import {mapGetters,mapMutations} from 'vuex';
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import MediaManager from "@/api/MediaManager";

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'
import PlayCircleOutline from 'vue-material-design-icons/PlayCircleOutline.vue'

export default {
    components: {CloseIcon,OpenInNewIcon,PlayCircleOutline},
	data: () => ({
        hasAnimations: false,
        reversed: false,
        viewer3DVisible: false, 
        meshURL: null,
        name: "",
        publicPath: process.env.BASE_URL,
    }),
    computed: {
        ...mapGetters(['logoURL','allPrefabs','currentSituationID'])
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),
        playAnimation(){
            if(!window.scene3DViewer.animationGroups[0].isPlaying){

                let animationGroup = window.scene3DViewer.animationGroups[0];
                if(this.reversed){
                    animationGroup.stop();
                    animationGroup.start(false, 1, animationGroup.to, 0);
                }else{
                    animationGroup.stop();
                    animationGroup.start(false, 1, 0, animationGroup.to);
                }

                this.reversed = !this.reversed;
            }
        },
        toggleViewer3D(){
            this.viewer3DVisible = !this.viewer3DVisible;
            this.setDialogueOpen(this.viewer3DVisible);
            this.viewer3DVisible ? this.showViewer() : this.hideViewer();
            
            if(!this.viewer3DVisible){
                window.scene3DViewer.animationGroups = [];
                this.reversed = false;
                this.hasAnimations = false;
            }
        },
        showViewer(){
            // Clear Scene
            window.scene3DViewer.materials.forEach(material => {
                material.dispose();
            });
            window.scene3DViewer.meshes.forEach(mesh => {    
                mesh.dispose();
            });

            window.engine3DViewer.displayLoadingUI();

            // Load new Model
            BABYLON.SceneLoader.ImportMesh("","", this.meshURL, window.scene3DViewer, (meshes) =>{ // onSuccess
                meshes[0].name = this.meshURL;

                meshes.forEach(mesh => {
                    this.optimizeMeshPerformance(mesh);
                });    

                // Configure Camera
                this.configureCamera();

                this.configurePipeline();
                
                // Set Skydome Texture
                // this.configureDome();
                
                if(window.scene3DViewer.animationGroups.length > 0)
                    this.hasAnimations = true;
                window.scene3DViewer.animationGroups.forEach(animationGroup => {
                    animationGroup.stop();
                });

                setTimeout(() => { this.playStartAnimation(); }, 100);

                window.engine3DViewer.hideLoadingUI();
                window.engine3DViewer.runRenderLoop(()=> { window.scene3DViewer.render(); });
            },(evt) => { // onProgress
                var loadedPercent = 0;
                if(evt.lengthComputable){
                    loadedPercent = (evt.loaded * 100 / evt.total).toFixed();
                }else{
                    var dlCount = evt.loaded / (1024 * 1024);
                    loadedPercent = Math.floor(dlCount * 100.0) / 100.0;
                }
                document.getElementById("v3-text").innerHTML = loadedPercent + "%";
            });
        },
        configureDome(){
            let dome = window.scene3DViewer.getNodeByName("V3-Dome");
            let prefab = this.allPrefabs.find(prefab => prefab.id == this.currentSituationID && prefab.type == "RoomImage");
            dome.photoTexture.dispose();
            dome.photoTexture = new BABYLON.Texture(MediaManager.getMedia(prefab.getSphereImageID()).url,window.scene3DViewer);
            dome.setEnabled(true);
        },
        configureCamera(){
            if(window.scene3DViewer.activeCamera){
                // window.scene3DViewer.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline("ssao", window.scene3DViewer.activeCamera);
                window.scene3DViewer.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline("default", window.scene3DViewer.activeCamera);
                window.scene3DViewer.activeCamera.dispose();
            }

            window.scene3DViewer.createDefaultCamera(true,true,true);
            let camera =  window.scene3DViewer.activeCamera;
            camera.invertRotation = false;
            camera.lowerRadiusLimit = camera.radius * 0.4;
            camera.radius *= 1.2;
            camera.upperRadiusLimit = camera.radius * 2;
            camera.alpha = 1;
            camera.beta = 1;
            camera.inputs.attached.pointers.buttons = [0,1];
            camera.wheelDeltaPercentage = 0.05;
            camera.pinchPrecision = 30;
            camera.inertia = 0.8;
        },
        configurePipeline(){
            // window.scene3DViewer.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("ssao", window.scene3DViewer.activeCamera);
            window.scene3DViewer.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("default", window.scene3DViewer.activeCamera);

            // Create the SSR post-process!
            // let isSafari = false;
            // var ua = navigator.userAgent.toLowerCase(); 
            // if(ua.indexOf('safari') != -1){ 
            //     if(!(ua.indexOf('chrome') > -1)){
            //         isSafari = true;
            //     }
            // }

            // if(!isSafari){
            //     let ssr = new BABYLON.ScreenSpaceReflectionPostProcess("ssr", window.scene3DViewer, 1.0, window.scene3DViewer.activeCamera);
            //     ssr.reflectionSamples = 6; // Low quality.
            //     ssr.strength = 1; // Set default strength of reflections.
            //     ssr.reflectionSpecularFalloffExponent = 2; // Attenuate the reflections a little bit. (typically in interval [1, 3])
            //     ssr.samples = 12;
            //     ssr.enableSmoothReflections = true;
            //     ssr.adaptScaleToCurrentViewport = true;
            // }
        },
        hideViewer(){
            // window.scene3DViewer.getNodeByName("V3-Dome").setEnabled(false);
            // window.scene3DViewer.getMeshByName(this.meshURL).dispose();

            // Clear Scene
            window.scene3DViewer.materials.forEach(material => {
                material.dispose();
            });
            window.scene3DViewer.meshes.forEach(mesh => {    
                mesh.dispose();
            });

            window.engine3DViewer.stopRenderLoop();
        },
        init3DViewer(){
            console.log("init3DViewer")
            const canvas = document.getElementById("v3-canvas");

            window.engine3DViewer = new BABYLON.Engine(canvas, true, { stencil: true, xrCompatible: false}, true);

            function customLoadingScreen() {}
            customLoadingScreen.prototype.displayLoadingUI = function () { document.getElementById("v3-loadingScreen").style.opacity = 1; };
            customLoadingScreen.prototype.hideLoadingUI = function () { document.getElementById("v3-loadingScreen").style.opacity = 0; setTimeout(() => {document.getElementById("v3-text").innerHTML = "0%"}, 1000);};
            window.engine3DViewer.loadingScreen = new customLoadingScreen();
            const resizeObserver = new ResizeObserver(() => {setTimeout(() => { window.engine3DViewer.resize(); }, 0); });
            resizeObserver.observe(canvas);

            window.scene3DViewer = new BABYLON.Scene(window.engine3DViewer);
            // window.scene3DViewer.debugLayer.show();
            window.scene3DViewer.clearColor = new BABYLON.Color3.White();
            // window.scene3DViewer.environmentTexture = new BABYLON.CubeTexture.CreateFromPrefilteredData(this.publicPath + "/media/ITP/environment.env", window.scene3DViewer);
            window.scene3DViewer.autoClear = false;
            window.scene3DViewer.autoClearDepthAndStencil = false;
            window.scene3DViewer.blockMaterialDirtyMechanism = true;
            window.scene3DViewer.enablePrePassRenderer();

            let light = new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(0, 1, 0), window.scene3DViewer);
            light.intensity = 1.5;

            // let dome = new BABYLON.PhotoDome("V3-Dome","", { resolution: 32, faceForward: false, size: 1000}, window.scene3DViewer);
            // dome.mesh.material.alpha = 0.2;
            // dome.scaling.y *= -1;
            // dome.setEnabled(false);

            this.configureCamera();
            this.initPipeline();
        },
        playStartAnimation(){
            let camera = window.scene3DViewer.activeCamera;
            BABYLON.Animation.CreateAndStartAnimation("",camera, "radius", 30, 80, camera.radius, camera.radius * 0.85, 0, this.ease);
            BABYLON.Animation.CreateAndStartAnimation("",camera, "alpha", 30, 80, camera.alpha, camera.alpha + 0.2, 0, this.ease);
            BABYLON.Animation.CreateAndStartAnimation("",camera, "beta", 30, 80, camera.beta, camera.beta + 0.2, 0, this.ease);
        },
        initPipeline(){
            // prePassRenderer
            window.scene3DViewer.prePassRenderer.samples = 1;
            
            // // SSAO
            // let ssao = new BABYLON.SSAO2RenderingPipeline("ssao", window.scene3DViewer, {
            //     ssaoRatio: 0.5, // Ratio of the SSAO post-process, in a lower resolution
            //     blurRatio: 1    // Ratio of the combine post-process (combines the SSAO and the scene)
            // });
            // ssao.samples = 16;
            // ssao.base = 0;
            // ssao.radius = 2;
            // ssao.totalStrength = 2;
            // ssao.maxZ = 600;
            // ssao.minZAspect = 1;
            // ssao.textureSamples = 8;
            
            
            // Default Pipeline
            let defaultPipeline = new BABYLON.DefaultRenderingPipeline("default", true, window.scene3DViewer);
            defaultPipeline.samples = 16;

            // defaultPipeline.bloomEnabled = true;
            // defaultPipeline.bloomThreshold = 0.9;
            // defaultPipeline.bloomWeight = 0.1;
            // defaultPipeline.bloomKernel = 128;
            // defaultPipeline.bloomScale = 0.5;

            // defaultPipeline.imageProcessing.exposure = 2;
			// defaultPipeline.imageProcessing.toneMappingEnabled = false;
			// defaultPipeline.imageProcessing.contrast = 1.8;
            // defaultPipeline.imageProcessing.imageProcessingConfiguration.toneMappingType = 1;
            // defaultPipeline.imageProcessing.colorCurvesEnabled = true;
            // defaultPipeline.imageProcessing.contrast = 2.0;
            // defaultPipeline.imageProcessing.exposure = 1.2;

            defaultPipeline.fxaaEnabled = true;
            defaultPipeline.fxaa.adaptScaleToCurrentViewport = true;
            defaultPipeline.fxaa.samples = 6; // 1 by default

            defaultPipeline.sharpenEnabled = true;
            defaultPipeline.sharpen.adaptScaleToCurrentViewport = false
            // defaultPipeline.sharpen.edgeAmount = 0.9; // 0.3 by default
        },
        optimizeMeshPerformance(mesh){
            mesh.isPickable = false;
            mesh.cullingStrategy = BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;  // BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD;
            mesh.freezeWorldMatrix();
            mesh.doNotSyncBoundingInfo = true;
            // mesh.convertToUnIndexedMesh();

            if(mesh.material){
                mesh.material.backFaceCulling = false;
                mesh.material.freeze();
            }
        },
    },
    mounted(){
        this.ease = new BABYLON.CubicEase();
        this.ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

        this.init3DViewer();

        window.addEventListener('openViewer3D',(e) => {
            this.meshURL = e.detail.meshURL;
            this.name = e.detail.name;

            this.toggleViewer3D();
        });
    },
    destroyed(){
        console.log("destroyed");
        window.engine3DViewer.dispose();
    }
}
</script>